<template>
	<div class="row">
        <div class="content-wrap">
            <div class="col-md-6" v-if="content_flag==false">
                <span  role="alert" aria-live="assertive" class="sr-only">{{languageData['loading']}}</span>
                <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
            </div>
            <!--Display module link under particular division-->
            <template v-if="content_flag==true">   
            <div class="col-md-6" v-for="(el,ky) in main_content" :key="ky">
                <article class="animate-box">
                    <div class="blog-img">
                        <div v-if="el['id_element']" class="video colorlib-video" :style="'background-image: url('+CONTENT_DOMAIN+'/img/helpwhereyouare_site/ThemeMegazine/elements/'+el['id_element']+'.jpg);'">
                            <h1 v-html="el['heading']" ></h1>
                        </div>                
                        <div v-else class="video colorlib-video" :style="'background-image: url('+CONTENT_DOMAIN+'/img/helpwhereyouare_site/ThemeMegazine/elements/001.jpg);'">
                            <h1 v-html="el['heading']" ></h1>
                        </div>
                    </div>
                    <div class="desc">               
                        <div class="article-heading">
                            <ul class="category">
                                <li v-for="(content,k) in el['content']" :key="k">
                                    <router-link :to="'/content/'+content['id_cr']+'/?d='+division_id+'&m='+module_id+'&c='+category_id+'&e='+el['id_element']" v-html="content['title']" >
                                    </router-link>
                                </li>            
                            </ul>
                        </div>
                        <div class="view-all-article">
                            <span>{{el['count']}} {{decodeHtmlLang(el['found'])}} </span>
                            <router-link :to="'/module/'+module_id+'/category/'+category_id+'/element/'+el['id_element']+'/division/'+division_id" class="btn btn-primary with-arrow" v-if="el['view'] !=''" v-html="el['view']"></router-link>
                            <div v-if="!el['count']" style="min-height:18px;" ></div>
                        </div>
                    </div>
                </article>
            </div>
            </template>
        </div>   
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'mainContentModuleCategory',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            module_id:this.$route.params.module_id,
            division_id:this.$route.params.division_id,
            languageData:this.$store.state.languageData,
            category_id:this.$route.params.category_id,
            isSticky: false,
            stickyClass: 'is_sticky',
            content_flag:false
        };        
    },
    components:{
        
    },
    /*mounted :function(){
        this.showContent()
    },*/
    computed :{
        menuItem(){return this.$store.state.menuVar}
    },
    created :function(){
        this.showContent(),
        window.addEventListener('scroll', this.handleScroll);
    },
    watch: {
        // call again the method if the route changes
        '$route': 'showContent'
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },    
	methods:{
      showContent(){
            this.content_flag=false;
            //console.log('okkkkkkk'+this.menuItem);
            this.category_id=this.$route.params.category_id
            this.$emit('content_ld_flagp_false')
            this.module_id=this.$route.params.module_id
            var api_private_key=this.get_api_key_mix('mols')
          axios.get(this.$store.state.apiUrl+'/module_cat_details',{
              params:{
                  id_module:'m'+this.module_id,
                  id_language:this.$store.state.companyData['id_language'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'], 
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_category:this.category_id,
                  privatekey:api_private_key           
              }
          })
          .then(response => {
                response = response.data
                //console.log(response);
                this.content_flag=true;
                this.main_content = response;
                this.$emit('content_ld_flagp_changed');
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0;
                var titleValue_d =this.$store.state.languageData['d'+this.$route.params.division_id]; 
                var titleValue_m =this.$store.state.languageData['m'+this.$route.params.module_id]; 
                var titleValue_c =this.$store.state.languageData['c'+this.$route.params.category_id];              
                var home = this.$store.state.languageData['d00']
                document.title = this.decodeHtmlLang(titleValue_d)+' | '+this.decodeHtmlLang(titleValue_m)+' | '+this.decodeHtmlLang(titleValue_c)+' | '+this.$store.state.companyData['name_company'];

                this.$nextTick(function () {
                })
              
          })
          .catch((error) => {
                this.main_content = [];
                this.customErrorHandler(error.response.status);
          });
          this.web_hits()
      },
      handleScroll(event){
            this.scrollPosition = window.scrollY
            if(this.scrollPosition>=270){
                this.isSticky=true
            }else{this.isSticky=false}
        }

      

    }
};
</script>
<style scoped>
.module-card{
    background-color: #ffffff8f;;
    /*min-height: 450px;*/
        padding: 0 5px 5px 20px;
            text-align: left;
            
}

.category li a {
    border-bottom: 1px solid #f7f7f74a;
    display: block;
    padding: 5px 0;
    color: #101010;
}
.category li a:hover{
    font-size: 14px;
    color: #434343;
    font-weight: bold;    
}
.category li {
    /* list-style: none; */
    font-size: 14px;
}
article .video {
    height: 166px;
}
article .blog-img{
    height: 166px;
}
.pagination{
    padding-left: 16px;
}
.pagination li a {
    border: none;
}
.pagination li a:hover, .pagination li a:focus,.pagination li.active a:hover, .pagination li.active a:focus  {
    border: none !important; 
}
.pagination li.active a {
    border: none !important; 
}
.is_sticky {
    position: fixed;
    background-color: #fffffffc;
    top: 0;
    /* right: 0;
    left: 0; */
    z-index: 1030;
    /* width: 100%; */
    -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    /* -webkit-box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1); */       
    padding: 0;
    margin:0;
    /* width:81%; */
}

/*new design */
article .colorlib-video a {
    font-size: 25px;
    line-height: 2;
    z-index: 1001;
    position: absolute;
    bottom: 0;
    left:0;
    margin-top: auto;
    margin-left: 0;
    width: 100%;
    height: 42px;
    /* display: table; */
    text-align: center;
    background: #1d1d1db0;
    color: whitesmoke;
    -webkit-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -ms-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -o-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -webkit-border-radius: 0%;
    -moz-border-radius: 0%;
    -ms-border-radius: 0%;
    border-radius: 0%;
}

article .colorlib-video h2 {
    font-size: 25px;
    line-height: 2;
    z-index: 1001;
    position: absolute;
    bottom: 0;
    left:0;
    margin-top: auto;
    margin-left: 0;
    width: 100%;
    height: 50px;
    /* display: table; */
    text-align: center;
    background: #1d1d1db0;
    color: whitesmoke;
    -webkit-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -ms-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -o-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -webkit-border-radius: 0%;
    -moz-border-radius: 0%;
    -ms-border-radius: 0%;
    border-radius: 0%;
    margin:0px;
}

article .colorlib-video h1 {
    font-size: 25px;
    line-height: 2;
    z-index: 1001;
    position: absolute;
    bottom: 0;
    left:0;
    margin-top: auto;
    margin-left: 0;
    width: 100%;
    height: 50px;
    /* display: table; */
    text-align: center;
    background: #1d1d1db0;
    color: whitesmoke;
    -webkit-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -ms-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -o-box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 14px 30px -15px rgba(0, 0, 0, 0.75);
    -webkit-border-radius: 0%;
    -moz-border-radius: 0%;
    -ms-border-radius: 0%;
    border-radius: 0%;
    margin:0px;
}

article .desc {
    padding: 1em;
    width: 100%;
    float: right;
    margin-top: 0;
    z-index: 1;
    background: #e4e4e4c2;
    position: relative;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
}
.article-heading {
    overflow-y: auto;
    height: 200px !important;
}
/* .article-heading::-webkit-scrollbar {
  display: none;
} */
.article-heading {
  -ms-overflow-style: none;
}
.view-all-article{
    /* padding: 13px 0 0 0;
    min-height: 54px;   */
    min-height: 48px !important;
    margin: 20px 0 0 0 !important;
    text-align: right !important;
}
.view-all-article span {
    font-size: 12px !important;
    padding: 0 10px 0 22px;
    color: #8e8e8e !important;
}
.content-wrap .col-md-6{
    padding-right: 10px !important;
    margin-top: 10px;
}
.content-wrap{
    padding-right: 21px;
    width: 100% !important;
}
@media screen and (max-width: 768px){
    article .blog-img {
        margin-bottom: 0px !important;
    }
    .content-wrap{
        padding-left: 0 !important; 
    }
}
</style>
